$(document).ready(function() {

   $('.modulebtns').on('click', function() {

      $('.module-radio-input').prop('checked', false);
       $('.module-radio-input').closest('.images').find('img').removeClass('selected');
        $('.modulebtns').removeClass('active');
        $(this).addClass('active');
        var moduleToShow = $(this).data('module-list');
        $('.module').hide();
        $('.module[data-module="' + moduleToShow + '"]').show();
        $('.hidden-modules-steps').val($(this).text());
    });


  
    $('.module').hide();
    $('.module[data-module="1"]').show(); 
  


  // Handle panel option selection in step 2
  $('.panneau-btn').click(function() {
    $('.panneau-btn').removeClass('active');
    $(this).addClass('active');
  });

$('.module-radio-input').change(function() {
  // Uncheck all other radio inputs in the same group
  $('.module-radio-input').not(this).prop('checked', false)
    .next('label').find('.img-wrap img').removeClass('selected');
  
  // Add or remove the 'selected' class based on the checked state of the current input
  var $label = $(this).next('label');
  if ($(this).is(':checked')) {
    $label.find('.img-wrap img').addClass('selected');
  } else {
    $label.find('.img-wrap img').removeClass('selected');
  }

  if($(this).val() == 'WOOD FLAT'){
     $('label[for="Sablé"]').hide();
  }
  else{
     $('label[for="Sablé"]').show();
  }
});



 $('.img-module-radio-input').on('change', function () {
    $('.img-wrap').removeClass('selected');
    if ($(this).is(':checked')) {
      $(this).closest('.img_option_module').find('.img-wrap').addClass('selected');
    }
  });


  
  
});





// =============================Multistep======================

let error = false;

function navigateSlides(currentSlide, nextSlide) {
    $("#progress_header li").eq($(".multistep-box").index(nextSlide)).addClass("active");
    currentSlide.hide();
    nextSlide.show();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}











const actualBtn = document.getElementById('actual-btn');
const fileChosen = document.getElementById('file-chosen');
const fileUrlInput = document.getElementById('file-url');
const fileUrlDoc = document.getElementById('file-doc-link');




actualBtn.addEventListener('change', function() {
    const file = this.files[0];
    fileChosen.textContent = file.name;

    const formData = new FormData();
    formData.append('file', file);

    fetch('https://rentside.website/invoice/file-upload', {
        method: 'POST',
        body: formData,
        redirect: 'follow',  // Ensures fetch will follow the redirect
        headers: {
            'Accept': 'application/json',
        }
    })
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 302) {
            // Handle redirect explicitly if needed
            return fetch(response.url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                }
            }).then(redirectResponse => redirectResponse.json());
        } else {
            throw new Error('File upload failed');
        }
    })
    .then(data => {
        if (data && data.url) {
            fileUrlDoc.value = data.url;
        } else {
            console.error('Response does not contain URL.');
        }
    })
    .catch(error => {
        console.error('Error uploading file:', error);
    });
});



 $(document).ready(function() {
    $(".fs_next_btn, .ss_next_btn, .ts_next_btn").click(function() {
    var currentStep = $(this).closest(".multistep-box");
    var allFilled = true;
    var cur_data = $(currentStep).data('step');


      if(cur_data == 1)
      {
        if ($('.module-radio-input:checked').length < 1) {
           allFilled = false;
        }
        countChecked();
      }
    
 currentStep.find("input[required]").each(function() {
    if ($(this).is(":radio")) {
        var name = $(this).attr("name");
        if ($("input[name='" + name + "']:checked").length === 0) {
            allFilled = false;
            console.log(name + " radio not selected");
        }
    }  else if ($(this).is(":file")) {
        if ($(this).prop("files").length === 0) {
            console.log("File input is empty");
            allFilled = false;
        }
    } else {
        if ($(this).val().trim() === "") {
            allFilled = false;
            console.log($(this).attr('name'));
            console.log("Text input is empty");
        }
    }
});

    if (allFilled) {
        let currentSlide = $(this).closest('.multistep-box');
        let nextSlide = currentSlide.next();
        navigateSlides(currentSlide, nextSlide);
    } else {
        currentStep.find('.message-wrapper').addClass('active');
    }

  
});



$(".previous").click(function() {
    let currentSlide = $(this).closest('.multistep-box');
    let previousSlide = currentSlide.prev();
    $("#progress_header li").eq($(".multistep-box").index(currentSlide)).removeClass("active");
    currentSlide.hide();
    previousSlide.show();
});

$(".submit_btn").click(function() {
    if (!error) {
        $(".main").addClass("form_submitted");
    }
    return false;
});


    function replaceFrenchCharacters(str) {
      const replacements = {
        'é': 'e',
        'è': 'e',
        'ê': 'e',
        'ë': 'e',
        'à': 'a',
        'â': 'a',
        'ç': 'c',
        'î': 'i',
        'ï': 'i',
        'ô': 'o',
        'ù': 'u',
        'û': 'u',
        'ü': 'u',
        // Add more replacements as needed
      };

      return str.replace(/[éèêëàâçîïôùûü]/g, function(match) {
        return replacements[match] || match;
      });
    }

   
    function updateInputNames() {
      $('input[name]').each(function() {
        let currentName = $(this).attr('name');
        let updatedName = replaceFrenchCharacters(currentName);
        if (currentName !== updatedName) {
          $(this).attr('name', updatedName);
        }
      });
    }
    updateInputNames();
    $(document).on('DOMNodeInserted', 'input[name]', function() {
      let currentName = $(this).attr('name');
      let updatedName = replaceFrenchCharacters(currentName);
      if (currentName !== updatedName) {
        $(this).attr('name', updatedName);
      }
    });
    $('.multistep-form input').each(function() {
        var originalName = $(this).attr('name');
        if (originalName) {
            var cleanedName = originalName.replace(/[^\w\[\]\s]/g, ''); // Include \s to preserve spaces
            $(this).attr('name', cleanedName);
        }
    });
    function createWindowField(index,selectedText) {
      let moduleText = $('.modulebtns.active').text();
      let text_3_placeholder_r3_s3 = $('#text_3_placeholder_r3_s3').text();
      let text_4_placeholder_r3_s3 = $('#text_4_placeholder_r3_s3').text();
      let text_5_placeholder_r3_s3 = $('#text_5_placeholder_r3_s3').text();
      let text_6_placeholder_r3_s3 = $('#text_6_placeholder_r3_s3').text();
      let text_7_placeholder_r3_s3 = $('#text_7_placeholder_r3_s3').text();
      let text_8_placeholder_r3_s3 = $('#text_8_placeholder_r3_s3').text();
      let text_9_placeholder_r3_s3 = $('#text_9_placeholder_r3_s3').text();
      let text_9_placeholder_r4_s3 = $('#text_9_placeholder_r4_s3').text();
         const required = index === 1 ? 'required' : '';
        return `
        <div class="row-col" id="window-${index}">
            <h3>Porte #${index} (${moduleText} - ${selectedText})</h3>
            <div class="row-col-form">
                <input type="number" step="any"  name="Hauteur[]" id="Hauteur${index}" class="input-text" placeholder="Hauteur (cm)" required>
                <input type="number" step="any"  name="Largeur[]" id="Largeur${index}" class="input-text" placeholder="Largeur (cm)" required>
                <input type="number" step="any"   name="Quantite[]"  min="1" id="Quantite{index}" placeholder="${text_9_placeholder_r4_s3}"  class="input-text" placeholder="Quantité">
                </div>
                <div class="row-col-form two-item">
                <input type="number" step="any"   name="Ecoincons_hauteur[]" id="Ecoincons_hauteur${index}" class="input-text" placeholder="${text_3_placeholder_r3_s3}" >
                <input type="number" step="any"   name="Ecoincons_largeur[]" id="Ecoincons_largeur${index}" class="input-text" placeholder="${text_4_placeholder_r3_s3}" >
                </div>
                <div class="row-col-form two-item">
                <input type="number" step="any"   name="Refoulement_hauteur[]" id="Refoulement_hauteur${index}" class="input-text" placeholder="${text_5_placeholder_r3_s3}" >
                <input type="number" step="any"   name="Refoulement_largeur[]" id="Refoulement_largeur${index}" class="input-text" placeholder="${text_6_placeholder_r3_s3}" >
                </div>
                <div class="row-col-form two-item">
                <input type="number" step="any"   name="Hauteur_plafond[]" id="Hauteur_plafond${index}" class="input-text" placeholder="${text_7_placeholder_r3_s3}" >
                <input type="number" step="any"   name="Hauteur_linteau[]" id="Hauteur_linteau${index}" class="input-text" placeholder="${text_8_placeholder_r3_s3}" >
                   
            </div>
             <div class="row  pdf-container ">
                            <h3>À télécharger</h3>
                          <div class="option-1-pdf optionpdf">
                            <a href="${text_9_placeholder_r3_s3} download="" data-pdf="Fichier - Prise de côte">Fichier - Prise de côtes</a>
                          </div>
                    </div>
        </div>`;
    }
function updateWindowFields() {
    let quantity = parseInt($('#f-input-box').val());
    let container = $('#windows-container');
    container.empty();

    // Get the selected image text
  var $selectedOptions = $('.step.step-1').find('.module-radio-input:checked');
    for (let i = 1; i <= quantity; i++) {
      var selectedText =  $selectedOptions.eq(i % $selectedOptions.length).val();
      console.log(selectedText);
        container.append(createWindowField(i, selectedText)); // Pass the selected text
    }
}
    updateWindowFields();
      function countChecked() {
    var totalChecked = $('.module-radio-input:checked').length;
    $('#f-input-box').val(totalChecked).trigger('change');
   updateWindowFields();
  }
    $('#f-btn-plus').on('click', function() {
        let quantityInput = $('#f-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity < parseInt(quantityInput.attr('max'))) {
            quantityInput.val(quantity + 1);
            updateWindowFields();
        }
    });
    $('#f-btn-minus').on('click', function() {
        let quantityInput = $('#f-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity > parseInt(quantityInput.attr('min'))) {
            quantityInput.val(quantity - 1);
            updateWindowFields();
        }
    });
    $('#f-input-box').on('input', function() {
        let quantityInput = $(this);
        let quantity = parseInt(quantityInput.val());
        if (quantity >= parseInt(quantityInput.attr('min')) && quantity <= parseInt(quantityInput.attr('max'))) {
            updateWindowFields();
        } else {
            // Reset to closest valid value
            if (quantity < parseInt(quantityInput.attr('min'))) {
                quantityInput.val(quantityInput.attr('min'));
            } else if (quantity > parseInt(quantityInput.attr('max'))) {
                quantityInput.val(quantityInput.attr('max'));
            }
            updateWindowFields();
        }
    });
    function createWindowField2(index) {
        return `
        <div class="row-col" id="window-volet-${index}">
            <h3>Volet #${index}</h3>
            <div class="row-col-form">
                <input  type="number" step="any" name="Hauteur[]" id="Hauteur${index}" class="input-text" placeholder="Hauteur (cm)">
                <input type="number" step="any"  name="Largeur[]" id="Largeur${index}" class="input-text" placeholder="Largeur (cm)">
            </div>
        </div>`;
    }
    function updateWindowFields2() {
        let quantity = parseInt($('#v-input-box').val());
        let container = $('#windows-container-2');
        container.empty();
        for (let i = 1; i <= quantity; i++) {
            container.append(createWindowField2(i));
        }
    }
    updateWindowFields2();
    $('#v-btn-plus').on('click', function() {
        let quantityInput = $('#v-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity < parseInt(quantityInput.attr('max'))) {
            quantityInput.val(quantity + 1);
            updateWindowFields2();
        }
    });
    $('#v-btn-minus').on('click', function() {
        let quantityInput = $('#v-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity > parseInt(quantityInput.attr('min'))) {
            quantityInput.val(quantity - 1);
            updateWindowFields2();
        }
    });
    $('#v-input-box').on('input', function() {
        let quantityInput = $(this);
        let quantity = parseInt(quantityInput.val());
        if (quantity >= parseInt(quantityInput.attr('min')) && quantity <= parseInt(quantityInput.attr('max'))) {
            updateWindowFields2();
        } else {
            // Reset to closest valid value
            if (quantity < parseInt(quantityInput.attr('min'))) {
                quantityInput.val(quantityInput.attr('min'));
            } else if (quantity > parseInt(quantityInput.attr('max'))) {
                quantityInput.val(quantityInput.attr('max'));
            }
            updateWindowFields2();
        }
    });
    $('.secondary-add-option input').on('change', function() {
    if ($('.secondary-add-option input:checked').val() === 'OUI') {
        $('.secondary-address').show();
    } else {
        $('.secondary-address').hide();
    }
});
 



   // FOrm Submition
     $('.multistep_form_2').submit(function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: 'https://rentside.website/invoice/contact', 
            data: $(this).serialize(),
            success: function (response) {
                // alert('Porte De Garage  successfully!');
                $('.multistep_form_2').hide();
                $('.portes-success').show();
              window.scrollTo(0, 0);
            },
            error: function (error) {
                alert('There was some Error');
                console.error(error);
            }
        });
    });
  




        // $('.img-module-radio-input').on('change', function () {
        //     let linteauxPdf = $('.option-1-pdf');
        //     let sideSystemPdf = $('.option-2-pdf');
        //     let pdfContainer = $('.pdf-container');
        //     pdfContainer.addClass('d-none');
        //     linteauxPdf.addClass('d-none');
        //     sideSystemPdf.addClass('d-none');
        //     if (this.checked) {
        //         pdfContainer.removeClass('d-none'); 
        //         if ($(this).val() === 'LINTEAUX') {
        //             linteauxPdf.removeClass('d-none');
        //         }
        //         if ($(this).val() === 'SIDE SYSTEM') {
        //             sideSystemPdf.removeClass('d-none');
        //         }
        //     }
        // });

// $(document).ready(function () {
//     $('.img-module-radio-input').on('change', function () {
//         let pdfContainer = $('.pdf-container');
//         let linteauxPdf = $('.option-1-pdf');
//         let sideSystemPdf = $('.option-2-pdf');

//         // Check if at least one checkbox is selected, if so, show the container
//         if ($('.img-module-radio-input:checked').length > 0) {
//             pdfContainer.removeClass('d-none');
//         } else {
//             pdfContainer.addClass('d-none');
//         }

//         // Toggle PDFs based on checkbox states
//         linteauxPdf.toggleClass('d-none', !$('#img-module-1-1').is(':checked'));
//         sideSystemPdf.toggleClass('d-none', !$('#img-module-1-2').is(':checked'));
//     });
// });



   
});


$(document).ready(function () {
  $('input[name="b7option"]').on('change', function () {
    if ($('#b7-op2').is(':checked')) {
      $('.box-8-info').removeClass('d-none'); // Show the div
    } else {
      $('.box-8-info').addClass('d-none'); // Hide the div
    }
  });
});


$(document).ready(function () {
  $('input[name="b7option"]').on('change', function () {
    if ($('#b7-op2').is(':checked')) {
        $('.onlyoption').addClass('d-none');
      $('.box-8-info').removeClass('d-none'); // Show the div
    } else {
      $('.box-8-info').addClass('d-none'); // Hide the div
      $('.onlyoption').removeClass('d-none');
    }
  });
});
